










FUNCTIONS = require "scripts/common"
module.exports =
	props: ["container"]
	components:
		postLink: require "components/archive/posts/postLink"
		spinner: require "components/common/spinner"
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		pageName: -> return this.$route.name
		projectName: -> return this.$route.params.projectName
		projectNo: -> return FUNCTIONS.getProjectNo this.projectName
	methods:
		renderText: (strJa, strEn) -> return if !this.isEnglish then strJa else strEn
		toPosts: (categorySlug) ->
			name = if this.isEnglish then "en_posts" else "posts"
			return {name: name,  params: {projectNo: this.projectNo,  category: categorySlug, page: 1}}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/about/latest.vue